import React, { useState, useEffect, useRef } from "react";
import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import SaveIcon from "@material-ui/icons/Save";
import CloseIcon from "@material-ui/icons/Close";

import PrintIcon from "@material-ui/icons/Print";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import moment from "moment";
import BiztranControls from "../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../hooks/UseFetchData"
import Modal_Frame from "../biztran_controls/Modal_Frame";
import { DatePickerInput } from 'rc-datepicker';
import Session from "react-session-api";
import { Save } from "@material-ui/icons";


const todate = new Date()
const fromdate = todate.getFullYear() - 1 + '/04/01';

// function useApiRef() {
//   const apiRef = useRef(null);
//   const _columns = useMemo(
//     () =>
//       columns.concat({
//         field: "__HIDDEN__",
//         width: 0,
//         renderCell: (params) => {
//           apiRef.current = params.api;
//           return null;
//         },
//       }),
//     [columns]
//   );
//   return { apiRef, columns: _columns };
// }

const AddEditExpense = (props) => {
    //debugger;
    //const classes = useStyles();
    const [TravelRequestNo, setTravelRequestNo] = useState('');
    const [TravelRequestID, setTravelRequestID] = useState('');
    const [TravelRequestDate, setTravelRequestDate] = useState('');
    const [UserName, setUserName] = useState('');
    const [LocationToTravel, setLocationToTravel] = useState('');
    const [PurposeOfTravel, setPurposeOfTravel] = useState('');
    const [ExpenseSheetCreatedOn, setExpenseSheetCreatedOn] = useState('');
    const [ExpenseDate, setExpenseDate] = useState('');
    const [EmpID, setEmpID] = useState('');
    const [Status, setStatus] = useState('');
    const [EmpName, setEmpName] = useState('');
    const [CityType, setCityType] = useState('');
    const [AccountsApprovedByID, setAccountsApprovedByID] = useState(Session.get("UID"));
    const [PaidAmount, setPaidAmount] = useState('');
    const [AccountsApprovedOn, setAccountsApprovedOn] = useState('')
    const [TravelFrom, setTravelFrom] = useState('');
    const [ModeOfTravelID, setModeOfTravelID] = useState('');
    const [ApprovedBy, setApprovedBy] = useState('');
    const [ApprovedOn, setApprovedOn] = useState('');
    const [AccApprovedBy, setAccApprovedBy] = useState(Session.get("UserName"));
    const [responseList, ListfetchData] = UseFetchData();
    const [AccApprovedOn, setAccApprovedOn] = useState('');
    const [PlannedAmount, setPlannedAmount] = useState('');
    const [tolExpAmount, settolExpAmount] = useState('');
    const [ExpenseType, setExpenseType] = useState('');
    const [ExpenseTypeID, setExpenseTypeID] = useState('');
    const [CheckInDate, setCheckInDate] = useState('');
    const [CheckOutDate, setCheckOutDate] = useState('');
    const [NoOfDays, setNoOfDays] = useState('');
    const [TravelMode, setTravelMode] = useState('');
    const [Distance, setDistance] = useState('');
    const [Time, setTime] = useState('');
    const [ExpAmount, setExpAmount] = useState('');
    const [UpperLimit, setUpperLimit] = useState('');
    const [TravelTo, setTravelTo] = useState('');
    const [ApproveAmt, setApproveAmt] = useState('');
    const [AccountApprovedAmt, setAccountApprovedAmt] = useState('');
    const [Remarks, setRemarks] = useState('');
    const[AccountsRemarks, setAccountsRemarks] = useState('');
    const [responseattachment, attachmentfetchData] = UseFetchData();

    const [tolExpAppAmount, settolExpAppAmount] = useState('');
    const [tolAccAppAmount, settolAccAppAmount] = useState('');
    const [isManagerApproval, setManagerApproval] = useState(props.isManager);

    const [PaidOn, setPaidOn] = useState('');
    const [pagename, setpagename] = useState(props.pagename);
    const [flag, setflag] = useState(props.pagename == "Home" ? true : true);
    const [flag01, setflag01] = useState(false);
    // console.log(props.poppopupData.[FunctionLocation);
    const [TotalPaidAmount, setTotalPaidAmount] = useState('');
    const [PaymentDetails, setPaymentDetails] = useState('');
    const [rows, setRows] = useState([]);
    const [LocationFromTravel, setTravelFromLocation] = useState([]);
    const [columns, setColumns] = useState([]);
    const [response, fetchData] = UseFetchData();
    const [responseAccAp, AccApfetchData] = UseFetchData();
    const [response01, fetchData01] = UseFetchData();
    const [responseprint, fetchDataprint] = UseFetchData();
    const [responseApprove, fetchDataapprove] = UseFetchData();
    const [responseReject, fetchDataReject] = UseFetchData();
    // const fromdate = new Date()
    const [ToDate, setToDate] = useState('');
    const [FromDate, setFromDate] = useState('');
    const [Description, setDescription] = useState('');
    const [ApproxExpAmt, setApproxExpAmt] = useState('');
    const [defaultToDate, setdefaultToDate] = useState('');
    const [ReasonToRejection, setReasonToRejection] = useState('');
    const [ApprovalStatus, setApprovalStatus] = useState([]);

    const [At1File, setAT1File] = useState(null);
    const [At2File, setAT2File] = useState(null);
    const [At3File, setAT3File] = useState(null);
    const [At1URL, setAt1URL] = useState(null);
    const [At2URL, setAt2URL] = useState(null);
    const [At3URL, setAt3URL] = useState(null);
    const [At1ID, setAt1ID] = useState(null);
    const [At2ID, setAt2ID] = useState(null);
    const [At3ID, setAt3ID] = useState(null);
    const [At1, setAt1] = useState(false);


    const poppopupData = () => {
        //debugger;
        // const bodyFormData = new FormData();
        // bodyFormData.append("TravelRequestID", props.TravelRequestID);
        // ListfetchData("Dashboard/GetbyID", bodyFormData);
        const bodyFormData = new FormData();
        bodyFormData.append("ExpenseID", props.ExpenseID);
        bodyFormData.append("TravelRequestID", props.TravelRequestID);
        bodyFormData.append("EmpID", Session.get("UID"));
        ListfetchData("ExpMangt/ExpenseListWeb", bodyFormData)
    }

    const popupGrid = () => {
        debugger;
        var bodyFormData = new FormData();
        bodyFormData.append("TravelRequestID", props.TravelRequestID);
        fetchData("Dashboard/ExpenseList", bodyFormData);

    }

    const submitApprove = () => {
        debugger;
        const bodyFormData = new FormData();
        bodyFormData.append("TravelRequestID", props.TravelRequestID);
        bodyFormData.append("ApprovalRemarks", '');
        bodyFormData.append("ApprovalStatus", "TR Approved");
        bodyFormData.append("ApprovedByID", Session.get("UID"));
        fetchDataapprove("ExpMangt/ApproveTravelRequestWeb", bodyFormData);
    }

    const Save = () => {
        debugger;
        // Validate that we have the required props
        if (!props.ExpenseID || !props.TravelRequestID) {
            alert("Missing required information. Please close and reopen the expense.");
            return;
        }

        const bodyFormData = new FormData();
        if(props.isManager == true){
            // Validate before proceeding
            const finalAmount = AccountApprovedAmt || ApproveAmt;
            if (finalAmount != null && finalAmount != "" && finalAmount < ApproveAmt && (!AccountsRemarks || AccountsRemarks.trim() === "")) {
                alert("Remarks are compulsory when approving less than the approved amount for some expenses.");
                return;
            }

            bodyFormData.append("TravelRequestID", props.TravelRequestID);
            bodyFormData.append("ExpenseID", props.ExpenseID);
            bodyFormData.append("ApprovedBy", "Manager");
            bodyFormData.append("ApprovalAMT", finalAmount);
            bodyFormData.append("ApprovedByID", Session.get("UID"));
            
            if (AccountsRemarks != null && AccountsRemarks != '') {
                bodyFormData.append("ApproverRemarks", AccountsRemarks);
            } else {
                bodyFormData.append("ApproverRemarks", "");
            }
            
            if (props.onAmountChange) {
                props.onAmountChange({
                    ExpenseID: props.ExpenseID,
                    AccountsApprovedAmt: AccountApprovedAmt,
                    ApprovedAmt: ApproveAmt,
                    Remarks: AccountsRemarks
                });
            }
            
            fetchDataapprove("ExpMangt/ExpApproval", bodyFormData);
            props.setOpen(false);
        }
        else{
            // Validate before proceeding
            const finalAmount = ApproveAmt || ExpAmount;
            if (finalAmount != null && finalAmount != "" && finalAmount < ExpAmount && (!Remarks || Remarks.trim() === "")) {
                alert("Remarks are compulsory when approving less than the expense amount for some expenses.");
                return;
            }

            bodyFormData.append("TravelRequestID", props.TravelRequestID);
            bodyFormData.append("ExpenseID", props.ExpenseID);
            bodyFormData.append("ApprovedBy", "Senior");
            bodyFormData.append("ApprovalAMT", finalAmount);
            bodyFormData.append("ApprovedByID", Session.get("UID"));
            
            if (Remarks != null && Remarks != '') {
                bodyFormData.append("ApproverRemarks", Remarks);
            } else {
                bodyFormData.append("ApproverRemarks", "");
            }
            
            if (props.onAmountChange) {
                props.onAmountChange({
                    ExpenseID: props.ExpenseID,
                    ApprovedAmt: ApproveAmt,
                    AccountsApprovedAmt: AccountApprovedAmt,
                    Remarks: Remarks
                });
            }
            
            fetchDataapprove("ExpMangt/ExpApproval", bodyFormData);
            props.setOpen(false);
        }
    }

    const submitReject = () => {
        debugger;
        const bodyFormData = new FormData();
        if (ReasonToRejection !== "") {
            bodyFormData.append("TravelRequestID", props.TravelRequestID);
            bodyFormData.append("ApprovalRemarks", ReasonToRejection);
            bodyFormData.append("ApprovalStatus", "TR Rejected");
            bodyFormData.append("ApprovedByID", Session.get("UID"));
            fetchDataReject("ExpMangt/ApproveTravelRequestWeb", bodyFormData);
        }
        else {
            alert('Please Enter Reason for Reject.');
        }
    }

    useEffect(() => {
        debugger;
        if (responseattachment !== undefined && responseattachment.length > 0) {
            for (var i = 0; i < responseattachment.length; i++) {
                debugger;
                if (responseattachment[i].FileName.toString() == "Attachment1") {

                    setAt1URL(responseattachment[i].ServerFilePath)
                    setAt1(true);
                    setAt1ID(responseattachment[i].AttachmentsID)
                }
                if (responseattachment[i].FileName == "Attachment2") {
                    setAt2URL(responseattachment[i].ServerFilePath)
                    setAt2ID(responseattachment[i].AttachmentsID)
                }
                if (responseattachment[i].FileName == "Attachment3") {
                    setAt3URL(responseattachment[i].ServerFilePath)
                    setAt3ID(responseattachment[i].AttachmentsID)
                }
            }

            // setAT1File((responseattachment[0].ServerFilePath));
            // setAT2File((responseattachment[0].At2FServerFilePathile));
            // setAT3File((responseattachment[0].AtServerFilePath3File));
        }
    }, [responseattachment]);

    const SaveExpense = (value) => {
        debugger;
        var bodyFormData = new FormData();
        bodyFormData.append("TravelRequestID", value.TravelRequestID);
        bodyFormData.append("EmpID", Session.get("UID"));
        bodyFormData.append("ExpenseID", value.id);

        if (value.AccountsRemarks !== null && value.AccountsRemarks !== "") {
            bodyFormData.append("AccountsRemarks", value.AccountsRemarks);
        } else {
            bodyFormData.append("AccountsRemarks", "");
        }
        if (value.AccountsApprovedAmt !== null && value.AccountsApprovedAmt !== "") {
            if (!isNaN(+value)) {
                alert('Please Enter Numeric Value only !..');
                return;
            }
            else {
                bodyFormData.append("AccountsApprovedAmt", value.AccountsApprovedAmt);
            }
        } else {

            alert('Please Enter Accounts Approved Amount !...');
            return;
        }

        AccApfetchData("Dashboard/ExpAccApproval", bodyFormData);
    }

    useEffect(() => {
        // Reset state when ExpenseID changes to prevent stale data
        if (props.ExpenseID) {
            setApproveAmt('');
            setAccountApprovedAmt('');
            setRemarks('');
            setAccountsRemarks('');
        }
        poppopupData();
        popupGrid();
        console.log("pagename", props.pagename);
    }, [props.ExpenseID, props.TravelRequestID])


    useEffect(() => {
        debugger;
        if ((responseApprove.Response === true)) {
            alert('Data Saved Succesfully.');
            props.setOpen(false);
            props.PopulateData();
        }
        else if (responseApprove.Response === false) {
            alert('Failed.');
        }
    }, [responseApprove])

    useEffect(() => {
        debugger;
        if ((responseReject.Response === true)) {
            alert('Data Saved Succesfully.');
            props.setOpen(false);
            props.PopulateData();
        }
        else if (responseReject.Response === false) {
            alert('Failed.');
        }
    }, [responseReject])

    useEffect(() => {
        if (response01.Response == true) {
            //debugger;
            props.setOpen(false);
            props.PopulateData();
        }

    }, [response01])

    useEffect(() => {
        //debugger;
    //     const bodyFormData = new FormData();
    //     bodyFormData.append("ExpenseID", props.ExpenseID);
    //     bodyFormData.append("TravelRequestNo", props.TravelRequestID);
    //     attachmentfetchData("ExpMangt/GetAttachmentsWeb", bodyFormData);
    // }, [])
        if (props.ExpenseID) {
            const bodyFormData = new FormData();
            bodyFormData.append("ExpenseID", props.ExpenseID);
            bodyFormData.append("TravelRequestNo", props.TravelRequestID);
            attachmentfetchData("ExpMangt/GetAttachmentsWeb", bodyFormData);
        }
    }, [props.ExpenseID, props.TravelRequestID])


    const submitForm = () => {
        if (pagename !== "Home") {
            const bodyFormData = new FormData();
            bodyFormData.append("TravelRequestID", props.TravelRequestID);
            bodyFormData.append("PaidOn", PaidOn);
            bodyFormData.append("TotalPaidAmount", TotalPaidAmount);
            bodyFormData.append("PaymentDetails", PaymentDetails);
            fetchData01("Dashboard/PaymentUpdate", bodyFormData);
        } else {
            const bodyFormData = new FormData();
            bodyFormData.append("TravelRequestID", props.TravelRequestID);
            bodyFormData.append("EmpID", Session.get("UID"));
            fetchData01("Dashboard/AccApproval", bodyFormData);
        }


    };

    const OpenFile = (Atfiles) => {
        var data = ""

        if (Atfiles == "AT1") {
            data = At1URL
        } else if (Atfiles == "AT2") {
            data = At2URL
        } else if (Atfiles == "AT3") {
            data = At3URL
        }
        if (data != "" && data != null) {
            window.open(data);
        } else {
            alert('File Not Found.');
        }
    }


    const Print = () => {
        debugger;
        if (props.TravelRequestID != "" && props.TravelRequestID != null && props.TravelRequestID != undefined) {
            const bodyFormData = new FormData();
            bodyFormData.append("TravelRequestID", props.TravelRequestID);
            fetchDataprint("Dashboard/PDFGenerate", bodyFormData);
        }
    }
    useEffect(() => {
        debugger;
        if (responseprint != undefined && responseprint.length > 0) {
            window.open(responseprint[0].FileURL);
        }
    }, [responseprint])


    useEffect(() => {
        if (responseList !== undefined && responseList.length > 0) {
            //debugger;
            setTravelRequestNo((responseList[0].TravelRequestNo));
            setExpenseDate(moment(responseList[0].ExpenseDate).format('DD-MMM-yyyy'));
            setUserName(responseList[0].EmpName);
            setLocationToTravel(responseList[0].LocationToTravel);
            setTravelFromLocation(responseList[0].LocationFromTravel);
            setPurposeOfTravel(responseList[0].PurposeOfTravel);
            setExpenseSheetCreatedOn(responseList[0].ExpenseSheetCreatedOn);
            setEmpName(responseList[0].EmpName);
            setApprovedBy(responseList[0].ApprovedBy);
            setPlannedAmount(responseList[0].ApproxExpAmount);
            setApprovedOn(responseList[0].ApprovedOn != null && responseList[0].ApprovedOn != "" ? moment(responseList[0].ApprovedOn).format('DD-MMM-yyyy') : null);
            setApproxExpAmt(responseList[0].ApproxExpAmount);
            settolExpAppAmount(responseList[0].TotalApprovedAmount);
            settolAccAppAmount(responseList[0].TotalAccAppAmt);
            setPaidOn(responseList[0].PaidOn != null && responseList[0].PaidOn != "" ? moment(responseList[0].PaidOn).format('DD-MMM-yyyy') : null);
            setTotalPaidAmount(responseList[0].TotalPaidAmount);
            setPaymentDetails(responseList[0].PaymentDetails);
            setStatus(responseList[0].ApprovalStatus);
            setFromDate(responseList[0].FromDate != null && responseList[0].FromDate != "" ? moment(responseList[0].FromDate).format('DD-MMM-yyyy') : null);
            setToDate(responseList[0].ToDate != null && responseList[0].ToDate != "" ? moment(responseList[0].ToDate).format('DD-MMM-yyyy') : null);
            if (responseList[0].ApprovalStatus == "Exp Approved") {
                setflag01(true)
                setflag(false)

            }
            setApprovalStatus(responseList[0].ApprovalStatus);
            setDescription(responseList[0].Description);
            setExpenseType(responseList[0].ExpenseType);
            setExpenseTypeID(responseList[0].ExpenseTypeID);
            setCityType(responseList[0].CityType);
            setCheckInDate(responseList[0].CheckInDate != null && responseList[0].CheckInDate != "" ? moment(responseList[0].CheckInDate).format('DD-MMM-yyyy') : null);
            setCheckOutDate(responseList[0].CheckOutDate != null && responseList[0].CheckOutDate != "" ? moment(responseList[0].CheckOutDate).format('DD-MMM-yyyy') : null);
            setTravelMode(responseList[0].ModeOfTravel);
            setTravelFrom(responseList[0].TravelFrom);
            setTravelTo(responseList[0].TravelTo);
            setDistance(responseList[0].DistanceTravelledInKm);
            setTime(responseList[0].TimeTakenInHrs);
            setExpAmount(responseList[0].ExpenseAmount);
            setUpperLimit(responseList[0].UpperCeiling);
            setAccountApprovedAmt(responseList[0].AccountsApprovedAmt || responseList[0].ApprovedAmt);
            setApproveAmt(responseList[0].ApprovedAmt || responseList[0].ExpenseAmount);
            setRemarks(responseList[0].Remarks);
            setAccountsRemarks(responseList[0].AccountsRemarks);
            console.log("Expense Typeid: ", responseList[0].ExpenseTypeID)


        }
    }, [responseList]);


    const openPath = (row) => {
        debugger;
        window.open(row.formattedValue);

    };





    return (<div>
        <Formik initialValues={{
            TravelRequestNo: TravelRequestNo, ExpenseDate: ExpenseDate, EmpID: EmpID, TravelFrom: TravelFrom, ModeOfTravelID: ModeOfTravelID,
            ApprovedBy: ApprovedBy, ApprovedOn: ApprovedOn, AccApprovedBy: AccApprovedBy, AccApprovedOn: AccApprovedOn, PlannedAmount: PlannedAmount, tolExpAmount: tolExpAmount,
            PaidOn: PaidOn, PaidAmount: PaidAmount, PaymentDetails: PaymentDetails
        }}
            onSubmit={() => submitForm()}
            enableReinitialize>
            {formik => {
                return <Form>
                    <Grid item xs={12} spacing={1} container direction="row">
                        <Grid item xs={12} spacing={1} container direction="row">
                            <Grid item xs={4} sm={4} md={2} lg={2}>
                                <label
                                    htmlFor={"TravelRequestNo"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"TR No : "}
                                </label>
                            </Grid>
                            <Grid item xs={8} sm={8} md={4} lg={4}>
                                <label
                                    htmlFor={"TravelRequestNo"}
                                    style={{
                                        // display: "block",
                                        width: "100%",
                                        fontWeight: "bold",
                                    }}
                                >
                                    {TravelRequestNo}
                                </label>
                            </Grid>
                            <Grid item xs={4} sm={8} md={2} lg={2}>
                                <label
                                    htmlFor={"ExpenseDate"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"Date : "}
                                </label>
                            </Grid>
                            <Grid item xs={8} sm={8} md={4} lg={4}>
                                <label
                                    htmlFor={"TravelRequestDate"}
                                    style={{
                                        // display: "block",
                                        width: "100%",
                                        fontWeight: "bold",
                                    }}
                                >
                                    {ExpenseDate}
                                </label>
                            </Grid>
                            <Grid item xs={6} sm={6} md={6} lg={6}>
                                <label
                                    htmlFor={"EmpID"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"Expense Type: "}
                                </label>
                            </Grid>
                            <Grid item xs={6} sm={6} md={6} lg={6}>
                                <label
                                    htmlFor={"EmpName"}
                                    style={{
                                        // display: "block",
                                        width: "100%",
                                        fontWeight: "bold",
                                    }}
                                >
                                    {ExpenseType}
                                </label>
                            </Grid>

                        </Grid>


                        {ExpenseTypeID == '6688b64f-4b7e-11ed-ad55-42010aa00007' || ExpenseTypeID == '4a61f883-4b7e-11ed-ad55-42010aa00007'
                            || ExpenseTypeID == '3b06fd98-4b7e-11ed-ad55-42010aa00007' || ExpenseTypeID == '18f3120b-6eee-11ed-8023-42010aa00007' ?
                            <Grid item xs={12} spacing={1} container direction="row">
                                <Grid item xs={6}>
                                    <label
                                        htmlFor={"City"}
                                        style={{
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {"City Type : "}
                                    </label>
                                </Grid>
                                <Grid item xs={6} >
                                    <label
                                        htmlFor={"City"}
                                        style={{
                                            // display: "block",
                                            fontWeight: "bold",
                                            width: "100%",
                                        }}
                                    >
                                        {CityType}
                                    </label>
                                </Grid>
                            </Grid>

                            : null}


                        {/* {ExpenseTypeID == '3b06fd98-4b7e-11ed-ad55-42010aa00007' || ExpenseTypeID == '18f3120b-6eee-11ed-8023-42010aa00007' ?
                            <Grid item xs={12} spacing={1} container direction="row">
                                <Grid item xs={6}>
                                    <label
                                        htmlFor={"ApprovedBy"}
                                        style={{
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {"From Date : "}
                                    </label>
                                </Grid>
                                <Grid item xs={6} >
                                    <label
                                        htmlFor={"ApprovedBy"}
                                        style={{
                                            // display: "block",
                                            fontWeight: "bold",
                                            width: "100%",
                                        }}
                                    >
                                        {FromDate}
                                    </label>
                                </Grid>
                            </Grid>

                            : null} */}

                        {ExpenseTypeID == '4a61f883-4b7e-11ed-ad55-42010aa00007' ?
                            <Grid item xs={12} spacing={1} container direction="row">
                                <Grid item xs={6}>
                                    <label
                                        htmlFor={"ApprovedBy"}
                                        style={{
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {"Check In Date : "}
                                    </label>
                                </Grid>
                                <Grid item xs={6} >
                                    <label
                                        htmlFor={"ApprovedBy"}
                                        style={{
                                            // display: "block",
                                            fontWeight: "bold",
                                            width: "100%",
                                        }}
                                    >
                                        {CheckInDate}
                                    </label>
                                </Grid>
                                <Grid item xs={6}>
                                    <label
                                        htmlFor={"ApprovedBy"}
                                        style={{
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {"Check out Date : "}
                                    </label>
                                </Grid>
                                <Grid item xs={6} >
                                    <label
                                        htmlFor={"ApprovedBy"}
                                        style={{
                                            // display: "block",
                                            fontWeight: "bold",
                                            width: "100%",
                                        }}
                                    >
                                        {CheckOutDate}
                                    </label>
                                </Grid>
                                <Grid item xs={6}>
                                    <label
                                        htmlFor={"ApprovedBy"}
                                        style={{
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {"Number of Days : "}
                                    </label>
                                </Grid>
                                <Grid item xs={6} >
                                    <label
                                        htmlFor={"ApprovedBy"}
                                        style={{
                                            // display: "block",
                                            fontWeight: "bold",
                                            width: "100%",
                                        }}
                                    >
                                        {NoOfDays}
                                    </label>
                                </Grid>
                            </Grid>

                            : null}


                        {ExpenseTypeID == '3b06fd98-4b7e-11ed-ad55-42010aa00007' || ExpenseTypeID == '18f3120b-6eee-11ed-8023-42010aa00007' ?
                            <Grid item xs={12} spacing={1} container direction="row">
                                <Grid item xs={6}>
                                    <label
                                        htmlFor={"ApprovedBy"}
                                        style={{
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {"Mode of travel : "}
                                    </label>
                                </Grid>
                                <Grid item xs={6} >
                                    <label
                                        htmlFor={"ApprovedBy"}
                                        style={{
                                            // display: "block",
                                            fontWeight: "bold",
                                            width: "100%",
                                        }}
                                    >
                                        {TravelMode}
                                    </label>
                                </Grid>
                                <Grid item xs={6}>
                                    <label
                                        htmlFor={"ApprovedBy"}
                                        style={{
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {"From Location : "}
                                    </label>
                                </Grid>
                                <Grid item xs={6} >
                                    <label
                                        htmlFor={"ApprovedBy"}
                                        style={{
                                            // display: "block",
                                            fontWeight: "bold",
                                            width: "100%",
                                        }}
                                    >
                                        {TravelFrom}
                                    </label>
                                </Grid>
                                <Grid item xs={6}>
                                    <label
                                        htmlFor={"ApprovedBy"}
                                        style={{
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {"To Location : "}
                                    </label>
                                </Grid>
                                <Grid item xs={6} >
                                    <label
                                        htmlFor={"ApprovedBy"}
                                        style={{
                                            // display: "block",
                                            fontWeight: "bold",
                                            width: "100%",
                                        }}
                                    >
                                        {TravelTo}
                                    </label>
                                </Grid>
                                <Grid item xs={6}>
                                    <label
                                        htmlFor={"ApprovedBy"}
                                        style={{
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {"Distance In KM : "}
                                    </label>
                                </Grid>
                                <Grid item xs={6} >
                                    <label
                                        htmlFor={"ApprovedBy"}
                                        style={{
                                            // display: "block",
                                            fontWeight: "bold",
                                            width: "100%",
                                        }}
                                    >
                                        {Distance}
                                    </label>
                                </Grid>
                                <Grid item xs={6}>
                                    <label
                                        htmlFor={"ApprovedBy"}
                                        style={{
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {"Time Taken In Hours : "}
                                    </label>
                                </Grid>
                                <Grid item xs={6} >
                                    <label
                                        htmlFor={"ApprovedBy"}
                                        style={{
                                            // display: "block",
                                            fontWeight: "bold",
                                            width: "100%",
                                        }}
                                    >
                                        {Time}
                                    </label>
                                </Grid>
                                <Grid item xs={6}>
                                    <label
                                        htmlFor={"ApprovedBy"}
                                        style={{
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {"Expense Amount : "}
                                    </label>
                                </Grid>
                                <Grid item xs={6} >
                                    <label
                                        htmlFor={"ApprovedBy"}
                                        style={{
                                            // display: "block",
                                            fontWeight: "bold",
                                            width: "100%",
                                        }}
                                    >
                                        {ExpAmount}
                                    </label>
                                </Grid>
                                <Grid item xs={6}>
                                    <label
                                        htmlFor={"ApprovedBy"}
                                        style={{
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {"Upper Limit : "}
                                    </label>
                                </Grid>
                                <Grid item xs={6} >
                                    <label
                                        htmlFor={"ApprovedBy"}
                                        style={{
                                            // display: "block",
                                            fontWeight: "bold",
                                            width: "100%",
                                        }}
                                    >
                                        {UpperLimit}
                                    </label>
                                </Grid>
                            </Grid>

                            : null}

                        <Grid item xs={12} spacing={1} container direction="row">

                            <Grid item xs={6}>
                                <label
                                    htmlFor={"ApproxExpAmt"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"Expense Amount :"}
                                </label>
                            </Grid>
                            <Grid item xs={6} >
                                <label
                                    htmlFor={"ApproxExpAmt"}
                                    style={{
                                        // display: "block",
                                        width: "100%",
                                        fontWeight: "bold",
                                    }}
                                >
                                    {ExpAmount}
                                </label>
                            </Grid>


                            <Grid item xs={6}>
                                <label
                                    htmlFor={"tolExpAmount"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"Upper Limit :"}
                                </label>
                            </Grid>
                            <Grid item xs={6} >
                                <label
                                    htmlFor={"tolExpAmount"}
                                    style={{
                                        fontWeight: "bold",
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {UpperLimit}
                                </label>
                            </Grid>


                        </Grid>
                        <Grid item xs={12} spacing={1} container rowSpacing={2} direction="row" >
                            <Grid item xs={4} style={{ display: At1URL ? "inline" : "none" }}>
                                <a href="javascript:;" onClick={() => { OpenFile("AT1"); }}  >Attachment 1</a>

                            </Grid>
                            <Grid item xs={4} style={{ display: At2URL ? "inline" : "none" }}>
                                <a href="javascript:;" onClick={() => { OpenFile("AT2"); }} >Attachment 2</a>

                            </Grid>
                            <Grid item xs={4} style={{ display: At3URL ? "inline" : "none" }}>
                                <a href="javascript:;" onClick={() => { OpenFile("AT3"); }} >Attachment 3</a>

                            </Grid>

                        </Grid>

                        
<Grid item xs={12} spacing={1} container rowSpacing={2} direction="row" >
    <Grid item xs={4}>
        <label
            htmlFor={"PaymentDetails"}
            style={{
                display: "block",
                width: "100%",
            }}
        >
            {"Approve Amount :"}
        </label>
    </Grid>
    <Grid item xs={8} >
        {props.isManager ? (
            // Read-only display for managers
            <label
                style={{
                    fontWeight: "bold",
                    width: "100%",
                }}
            >
                {ApproveAmt || ExpAmount}
            </label>
        ) : (
            // Editable input for non-managers
            <BiztranControlsFormik
                autoFocus="autofocus"
                control="input"
                type="text"
                name="ReasonToRejection"
                value={ApproveAmt || ExpAmount}
                onChange={(e) => {
                    setApproveAmt(e.target.value)
                }}
            />
        )}
    </Grid>
</Grid>

                        {props.isManager && (
            <Grid item xs={12} spacing={1} container rowSpacing={2} direction="row" >
                <Grid item xs={4}>
                    <label
                        htmlFor={"SeniorPaymentDetails"}
                        style={{
                            display: "block",
                            width: "100%",
                        }}
                    >
                        {"Senior Approve Amount :"}
                    </label>
                </Grid>
                <Grid item xs={8} >
                    <BiztranControlsFormik
                        autoFocus="autofocus"
                        control="input"
                        type="text"
                        name="ReasonToRejection"
                        value={AccountApprovedAmt || ApproveAmt}
                        onChange={(e) => {
                        setAccountApprovedAmt(e.target.value)
                        }}
                    />
                </Grid>
            </Grid>
        )}


                        <Grid item xs={12} spacing={1} container rowSpacing={2} direction="row" >
                            <Grid item xs={4}>
                                <label
                                    htmlFor={"PaymentDetails"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"Remarks :"}
                                </label>
                            </Grid>
                            <Grid item xs={8} >
                                <BiztranControlsFormik
                                    autoFocus="autofocus"
                                    control="input"
                                    type="text"
                                    name="ReasonToRejection"
                                    //ref={ref}
                                    value={props.isManager ? AccountsRemarks : Remarks}
                                    //options={ASIcmb}                   
                                    onChange={(e) => {
                                        //setRemarks(e.target.value)
                                        //handleChange()
                                        if (props.isManager) {
                                            setAccountsRemarks(e.target.value);
                                        } else {
                                            setRemarks(e.target.value);
                                        }
                                    }}
                                />

                            </Grid>
                        </Grid>

                        <Grid item xs={12}>
                            <div style={{ width: '100%' }}>
                                <div style={{ display: 'flex', marginTop: 5, justifyContent: 'center', alignContent: "center" }}>

                                    <BiztranControls.Button
                                        text="Save"
                                        startIcon={<SaveIcon />}
                                        onClick={Save}
                                    //type="submit"
                                    />

                                </div>
                            </div>
                        </Grid>
                    </Grid>


                </Form>
            }}
        </Formik>

    </div >)

}
export default AddEditExpense;